import React from 'react';
import { Form,Alert } from 'antd';
import NHFetch from "./NHFetch";
import style from './print.css';
import TitleTop from './Assembly/titleTop';

class KzxxFormcComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dmkmcList: {}
        }
    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

    render() {
        const { form, initData } = this.props;
        //提示信息
        let AlertParams = {
            description: '',
            type: 'info'
        }
        //信息采集字段分类
        const infoItems = [];
        let reactid = 0;

        if (initData) {
            //表单信息、表单字段信息
            const { zdglVOs = [] } = initData;
            if (zdglVOs != null) {
                if (zdglVOs.length > 0) {
                    let array = [];
                    //循环过滤出多行文本框的key，偶数在左，奇数在右，相应的同行的另一条文本也需要加宽
                    for (let key in zdglVOs) {
                        let { kjcs } = zdglVOs[key];
                        let kjcsjson = JSON.parse(kjcs);
                        if (kjcsjson.type === "textarea") {
                            if (key % 2 === 0) { 
                                array.push(Number.parseInt(key));
                                array.push(Number.parseInt(key) + 1);
                            } else {
                                array.push(Number.parseInt(key));
                                array.push(Number.parseInt(key) - 1);
                            }
                        }
                    }
                    //显示表单字段信息
                    for (let key in zdglVOs) {
                        //字段状态、是否必填、默认值、字段标识、字段名称、控件参数、字段值
                        let { zdbz, zdmc, kjcs, zdz, zdzt} = zdglVOs[key]; //表单字段
                        let zdzmc = '';
                        let kjcsjson = JSON.parse(kjcs);
                        
                        if (kjcsjson.type === "select") {
                            if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                                this.getDmkMc(kjcsjson.dataTag, zdbz);
                            }
                            let list = this.state.dmkmcList[zdbz];
                            list && list.map(item => {
                                if (item.VALUE === zdz) {
                                    zdzmc = item.LABEL;
                                }
                            })
                        }else if(kjcsjson.type === "switch"){
                            zdzmc = (zdz === "1" || zdz === true) ? kjcsjson.checkedText:kjcsjson.uncheckedText;
                        } else if(kjcsjson.type === "radio"){
                            kjcsjson.options&&kjcsjson.options.map((item,key)=>{
                                if(item.value === zdz){
                                    zdzmc = item.label;
                                }
                            })
                        }else {
                            zdzmc = zdz;
                        }

                        let formItem;
                        formItem = (kjcsjson.type === 'textarea' ? 
                        (
                            <div key={'div' + reactid++} 
                                style={ zdzt==="3" ? {display:"none"} : {}} 
                                className={style.kzxx_item_textarea}
                            >
                                <div className={style.kzxx_label}>{zdmc}：</div>
                                <div className={style.kzxx_name_textarea}>
                                    {
                                        zdzmc
                                    }
                                </div>
                            </div>

                        )
                        :
                        (
                            <div key={'div' + reactid++} 
                                style={ zdzt==="3" ? {display:"none"} : {}} 
                                className={style.kzxx_item}
                            >
                                <div className={style.kzxx_label}>{zdmc}：</div>
                                <div className={style.kzxx_name}>
                                    {
                                        zdzmc
                                    }
                                </div>
                            </div>

                        ));
                        infoItems.push(formItem);
                    }
                } else {
                    //未找到表单配置的采集字段信息
                    AlertParams['description'] = '当前未配置采集信息项';
                    AlertParams['type'] = 'warning';
                }
            }
        }


        return (
            <div>
                {infoItems.length > 0 &&
                    <div>
                        <TitleTop
                            title="扩展信息"
                            extra={false}
                        />
                        {
                            infoItems.length > 0 ?
                                <Form>
                                    <div className="p-sw-big" style={{padding: '14px 28px'}}>
                                        <div className={style.kzxx_list}>
                                            {infoItems}
                                        </div>
                                    </div>
                                </Form>
                                :
                                <Alert style={{ marginTop: 20 }}
                                    {...AlertParams}
                                    showIcon
                                />
                        }
                    </div>
                }
            </div>
        )
    }

}

const KzxxFormc = Form.create()(KzxxFormcComponent);
export default KzxxFormc;


// WEBPACK FOOTER //
// ./components/yxxc/print/KzxxFormc.js